import "core-js/modules/es.number.constructor.js";
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event';
export default {
  props: {
    // 弹出层的最小宽度
    minWidth: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      visible: false,
      popoverWidth: this.minWidth
    };
  },
  methods: {
    updatePopoverWidth: function updatePopoverWidth() {
      if (this.$refs.reference) {
        var width = this.$refs.reference.getBoundingClientRect().width;
        this.popoverWidth = Math.max(width, this.minWidth);
      } else {
        this.popoverWidth = this.minWidth;
      }
      if (this.$refs.popover) {
        this.$refs.popover.updatePopper();
      }
    },
    handleShow: function handleShow() {
      this.$emit('show');
    },
    handleHide: function handleHide() {
      this.$emit('hide');
    }
  },
  mounted: function mounted() {
    this.updatePopoverWidth();
    addResizeListener(this.$refs.reference, this.updatePopoverWidth);
  },
  beforeDestroy: function beforeDestroy() {
    removeResizeListener(this.$refs.reference, this.updatePopoverWidth);
  }
};